// extracted by mini-css-extract-plugin
export default {"exportToExcelButton":"styles_exportToExcelButton__uhiWu","icon":"styles_icon__O7KOJ"};